import {Component} from '@angular/core';
import {NavController, ToastController} from 'ionic-angular';


import {ChangePasswordPage} from "../change-password/change-password";

import {MsgManager} from '../../providers/msg-manager';
import {CART, STOCKCART} from '../../providers/data';
import {Api} from '../../providers/api';
import {CartManager} from '../../providers/cart-manager';
import {GVLogger} from "../../services/gv-logger";
import {LoginPage} from "../login/login";

/*
 Generated class for the LoginPage page.

 See http://ionicframework.com/docs/v2/components/#navigation for more info on
 Ionic pages and navigation.
 */
@Component({
  selector: 'page-my-account',
  templateUrl: 'my-account.html'
})
export class MyAccountPage {

  disabledTrue:boolean = true;

	cart:any;
	firstName:string;
	lastName:string;
  formStatus:boolean = false;
  stockCart: any;


  constructor(public nav: NavController,
    private api:Api,
    private toastController:ToastController,
    private msgManager:MsgManager,
    private cartManager:CartManager, private gVLogger: GVLogger) {
    this.cart = CART;
    this.stockCart = STOCKCART;
  	this.firstName = this.cart.user.firstName;
  	this.lastName = this.cart.user.lastName;
    this.validateForm();
  }


  // go to changing password page
  changePassword() {
    this.nav.push(ChangePasswordPage);
  }

  updateInfo(){
    let body = this.genrateBody();
    this.updateCall(body);
  }

  genrateBody(){
    return {
          userId: this.cart.user.id,
          changeBy: this.cartManager.getSalesPerson().id,
          userName: this.cart.user.userName,
          password: this.cart.user.pass,
          // userStatus: tempState,
          userEmail: this.cart.user.email,
          userFirstName: this.firstName,
          userLastName: this.lastName,
          userPhone: this.cart.user.phoneNo,
          userRole: this.cart.user.roleId,
          userStatus: 1

    }
  }

   updateCall(body){
    this.validateForm();
    if(this.formStatus){
      this.gVLogger.log("Update Call...");

       this.gVLogger.log(body);
       this.api.post("users/updateIntelliRepUser",body).map(res => res.json()).subscribe(result =>{
         if(result.status == "401"){ // check for session out
           this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
           this.nav.setRoot(LoginPage);
         }
         if(result.status == "200"){
           this.cart.user.firstName = this.firstName;
           this.cart.user.lastName = this.lastName;
           this.msgManager.toastMsg(result.message);
           this.formStatus = false;
         }else{

           this.msgManager.toastMsg(result.message);
         }

       }, error =>{
         this.msgManager.toastMsg(this.msgManager.getWentWrongMsg());

       });
    }else{
      this.msgManager.toastMsg("Complete Form First.");
    }
  }

validateForm(){

  if(this.firstName == "" || this.lastName == ""){
    this.formStatus = false;
  }else{
    this.formStatus = true;
  }

}



}



// WEBPACK FOOTER //
// ./src/pages/my-account/my-account.ts